const PlusIcon = () => {
    return (
        <svg className="inline-block align-middle" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.99984 1.16666V12.8333M1.1665 6.99999H12.8332" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};
  
export default PlusIcon;
  
